import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {

    downloadSPChannel = new Subject();
    
    repository = new IndexRepository()

    constructor() {
        this.downloadSPChannel.next({status: apiResponse.INITIAL})
    }
    
    fetchDownloadSP = async (query) => {
        try {
            this.downloadSPChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadSP(query).then((result) => {
                this.downloadSPChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadSPChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { }
    }
}

export default IndexBloc